import React, { useState } from "react";
import "./index.css";
import { PlusOutlined } from "@ant-design/icons";
import projects from "./json/projects.json";
import configurations from "./json/configurations.json";

import {
  AutoComplete,
  Button,
  Cascader,
  Checkbox,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Slider,
  Switch,
  TreeSelect,
  Upload,
  notification,
} from "antd";
import axios from "axios";

const { TextArea } = Input;

const App = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [projectOpts, setProjectOpts] = React.useState([]);
  const mobile = Form.useWatch("mobile", form);

  const fetchProjectOpts = async () => {
    await axios
      .get(
        "https://nynexrealty.glitz.apps.enrichr.co/public/companies/17cf8b44-c1f8-4b8b-a7cd-13a5789c4bf6/external_api/projects"
      )
      .then((res) => setProjectOpts(res.data.projects))
      .catch((e) => console.log(e));
  };

  React.useEffect(() => {
    fetchProjectOpts();
  }, []);

  console.log(projectOpts, "pots");
  return (
    <>
      {contextHolder}
      <Form
        style={{ padding: "25px", maxWidth: "600px", margin: "auto" }}
        form={form}
        labelCol={{ span: 80 }}
        wrapperCol={{ span: 20 }}
        layout="vertical"
        initialValues={{
          name: "",
          email: "",
          mobile: "",
          project: "",
          source: "",
          sub_source: "",
          user_email: "",
          comment: "",
        }}
        onFinish={async (values) => {
          setIsLoading(true);
          try {
            const { data } = await axios.post(
              `https://glitz.apps.enrichr.co/public/companies/${process.env.REACT_APP_COMPANY_ID}/leads-all`,
              { ...values, source: "Tele Caller" }
            );
            if (data) {
              form.resetFields();
              api["success"]({
                message: "Form Submitted",
                description: "The Form has been submitted successfully.",
              });
              setIsLoading(false);
            }
          } catch (error) {
            api["error"]({
              message: "Something Went Wrong",
            });
            setIsLoading(false);
          }
        }}
      >
        <Form.Item
          style={{ marginBottom: "10px" }}
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter your name" }]}
        >
          <Input placeholder="Name" style={{ marginTop: "5px" }} />
        </Form.Item>
        <Form.Item
          style={{ marginBottom: "10px" }}
          name="mobile"
          label="Mobile Number"
          on
          rules={[
            {
              required: true,
              message: "Please enter your mobile number",
            },
          ]}
        >
          <Input
            placeholder="Mobile Number"
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key) || event.target.value.length > 9) {
                event.preventDefault();
              }
            }}
            onChange={(e) => {
              if (!isNaN(e.target.value)) {
                form.setFieldValue("mobile", e.target.value);
              }
            }}
            value={mobile}
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: "10px" }} label="Email" name="email">
          <Input placeholder="Email" type="email" />
        </Form.Item>
        <Form.Item
          style={{ marginBottom: "10px" }}
          label="Project"
          name="project"
          rules={[{ required: true, message: "Please select a project" }]}
        >
          <AutoComplete
            options={projectOpts.map((obj) => ({ value: obj.name }))}
            placeholder="Projects"
            filterOption={(inputValue, values) => {
              return (
                values?.value
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              );
            }}
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "10px" }}
          label="Configurations"
          name="configuration_nynex"
        >
          <AutoComplete
            options={configurations.map((obj) => ({ value: obj.config }))}
            placeholder="Configurations"
            filterOption={(inputValue, values) => {
              return (
                values?.value
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              );
            }}
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "10px" }}
          name="sub_source"
          label="Sub Source"
        >
          <Input placeholder="Sub Source" />
        </Form.Item>
        <Form.Item
          style={{ marginBottom: "10px" }}
          name="user_email"
          label="User Email"
        >
          <Input placeholder="User Email" />
        </Form.Item>
        <Form.Item
          style={{ marginBottom: "10px" }}
          name="comment"
          label="Comments"
        >
          <TextArea
            placeholder="Comments"
            rows={5}
            style={{ resize: "none" }}
          />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 10, offset: 5 }}>
          <Button
            loading={isLoading}
            disabled={isLoading}
            type="primary"
            style={{ width: "100%" }}
            htmlType="submit"
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default App;
